import * as React from 'react'
import { Analysis, ChatSession, OrgSnapshot } from './types'

type WfiContext = {
  analyses: Analysis[]
  chats: ChatSession[]
  currentChatId: number | null
  deleteChat: (id: number) => void
  orgSnapshot: OrgSnapshot | null
  skillRequirements: Map<number, number>
  starChat: (id: number) => void
  unstarChat: (id: number) => void
  switchChat: (chatId: number | null, orgSnapshotId: number | null) => void
}

export const WfiContext = React.createContext<WfiContext>({
  analyses: [],
  chats: [],
  currentChatId: null,
  deleteChat: () => {},
  orgSnapshot: null,
  skillRequirements: new Map(),
  starChat: () => {},
  unstarChat: () => {},
  switchChat: () => {},
})

export const useWfiContext = () => React.useContext(WfiContext)
